import { VerifyRecipientTokenSuccessResponse } from './verifyRecipientToken.types'

interface VerifyRecipientTokenState {
  loading: boolean
  success: VerifyRecipientTokenSuccessResponse | null
  error: string | null
}

const initialState: VerifyRecipientTokenState = {
  loading: false,
  success: null,
  error: null
}

export default initialState
